import React, { Fragment } from "react";
import AdsenseComponent from "./AdsenseComponent";

const Footer = () => {
  return (
    <Fragment>
      <AdsenseComponent />
      <div className="bg-gray-800 text-gray-100 text-center text-xs py-4 sm:mt-5">
        <div>جميع الحقوق محفوظة © {new Date().getFullYear()}</div>
        <div className="text-center text-gray-100 text-xs text-center py-4 flex flex-row justify-center items-center gap-1">
          <span> تم تصميم وتطوير هذا الموقع بواسطة </span>
          <p
            style={{
              color: "#f0ad4e",
              textDecoration: "underline",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "1.2rem",
            }}
            onClick={() => {
              window.open("https://ali-hatem-ramadan.vercel.app/", "_blank");
            }}
          >
            علي حاتم رمضان
          </p>
        </div>
      </div>
    </Fragment>
  );
};

export default Footer;
